// extracted by mini-css-extract-plugin
export default {"bottomSheet":"cookie-consent-CookieConsentModal-bottomSheet-35bf928c","popUpWindow":"cookie-consent-CookieConsentModal-popUpWindow-ebb26e47"};